import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import { merge } from "jquery";
import { id } from "date-fns/locale";
import Select from "react-select";
import label from "../label";
import { Table } from "react-bootstrap";
import { components } from "react-select";
import { render } from "@testing-library/react";
import ModalEditInUpdate from "./ModalEditInUpdate";
import { preconnect } from "react-dom";
import { useId } from "react";
import { Item } from "./item";
import { use } from "react";
import { useFetcher } from "react-router-dom";

const RenderModal = ({
  dataChange,
  setChangeData,
  dataChangeRef,
  handleChangeData,
  dataSearch,
  proxy,
  _token,
  showFields,
  isFields,
  isBulkUpdate,
  dataUpdate,
  mappedData,
  renderEdit,
  setRenderEdit,
  lang,
  SETDATA,
  field,
}) => {
  const lastItem = dataSearch[dataSearch.length - 1];

  const [dataSuggestion, setDataSuggestion] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [localState, setLocalState] = useState(dataChange);
  const [dataModal, setDataModal] = useState([]);
  const [isDataUpdate, setIsDataUpdate] = useState({});
  const [tempData, setTempData] = useState({});
  const [tempHandleChange, setTempHandleChange] = useState({});
  const refParam = useRef(null);
  const [cloneDataChange, setCloneDataChange] = useState(
    dataChange[dataUpdate]?.["3MLĐB"]
  );
  const [isCallDataSuggestion, setCallDataSuggestion] = useState({
    state: false,
    alias: "",
    item: "",
    data: [],
    isBulkUpdate: false,
  });
  const [data, setData] = useState([]);
  const [isData, setIsData] = useState([]);
  const [params, setParams] = useState(null);

  const ref = useRef({});
  const refParams = useRef();
  useEffect(() => {
    if (
      params &&
      // Object.values(params).length > 0 &&
      isCallDataSuggestion.state
    ) {
      fetch(`${proxy()}/api/PXK/ldb/${params}`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res && res.length > 0) {
            const { alias, item, isBulkUpdate } = isCallDataSuggestion;
            const options = res.map((item) => {
              if (item[alias]) {
                return {
                  ...item,
                  label: item["label"],
                  value: item["label"],
                };
              }
            });
            setDataSuggestion(options);
            if (dataUpdate !== null) {
              setTempHandleChange({
                res,
                item,
                ex: {},
                dataUpdate,
                isBulkUpdate,
              });
              setCloneDataChange(options);
              // handleChangeData(res, item, {}, undefined, isBulkUpdate);
            } else {
              handleChangeData(res, item, {}, undefined, isBulkUpdate);
            }
          }
        })
        .finally(() => {
          setCallDataSuggestion({
            state: false,
          });
        });
    }
  }, [params, isCallDataSuggestion]);

  useEffect(() => {
    fetch(`${proxy()}/api/PXK/optionLDB`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data.length > 0) {
          const options = data.map((d) => {
            if (d["3MLĐB"]) {
              return {
                value: d,
                label: d["3MLĐB"],
                ...d,
              };
            }
          });
          setIsData(options);
        }
      });
  }, []);
  useEffect(() => {
    if (refParam.current) {
      setParams(refParam.current);
    }
  }, [refParam]);

  useEffect(() => {
    const findApi = isFields.find(
      (item) => item.child_fields && item.child_fields.length > 0
    );
    if ((ref.current && ref.current?.url) || findApi) {
      // const { url, alias } = ref.current;
      const {
        child_api: { url },
        value,
        child_params,
      } = findApi;
      const alias = value;
      refParams.current = child_params;
      if (url) {
        fetch(`${proxy()}${url}`, {
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { data } = res;
            if (data && data.length > 0) {
              const options = data.map((item) => {
                if (item[alias]) {
                  return {
                    ...item,
                    label: item[alias],
                    value: item[alias],
                  };
                }
              });
              setData(options);
            }
          });
      }
    }
  }, [isFields, ref]);

  // const loadOptions = async (page = 0, search = "", child_api, alias) => {
  //   let newData = {
  //     options: [],
  //     hasMore: false,
  //     additional: {
  //       page: 0,
  //     },
  //   };
  //   try {
  //     const response = await fetch(`${proxy()}${child_api.url}`, {
  //       headers: {
  //         Authorization: _token,
  //         "content-type": "application/json",
  //         "data-amount": 15,
  //       },
  //     });
  //     if (!response.ok) {
  //       throw new Error(`HTTP error: ${response.status}`);
  //     }
  //     const res = await response.json();
  //     const { data, total } = res;
  //     if (data && data.length > 0) {
  //       const options = data.map((item) => {
  //         if (item[alias]) {
  //           return {
  //             ...item,
  //             label: item[alias],
  //             value: item[alias],
  //           };
  //         }
  //       });
  //       setDataSuggestion(options)
  //       newData = {
  //         options: options,
  //         hasMore: page + 15 < total,
  //         additional: {
  //           page: page + 15,
  //         },
  //       };
  //     }
  //   } catch (error) {
  //     console.error("Error fetching:", error);
  //   }
  //   return newData;
  // };
  const handleInputChange = (value, key, type) => {
    setTempData((prev) => ({ ...prev, [key]: value }));
  };
  const handleSave = () => {
    // handleChangeData(tempData, item, {}, dataUpdate, true);
  };
  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  if (isFields && isFields.length > 0) {
    // if (renderEdit && refParams.current && refParams.current.length > 0) {
    //   const check = refParams.current.find(({ value }) =>
    //     isFields.map(({ value }) => value).includes(value)
    //   );
    //   if (check) {
    //     const newParams = dataChange[dataUpdate]?.[check?.value];
    //     if (newParams !== params) {
    //       setParams(newParams);
    //     }
    //   }
    // }
    return renderEdit ? (
      <>
        <form style={{ padding: "5px 5em" }}>
          {(dataSearch[dataUpdate]
            ? [dataSearch[dataUpdate]]
            : dataSearch
          )?.map((row, index) =>
            mappedData.map((item, idx) => {
              const values = item?.values || item.value;
              return (
                <div className="mb-3">
                  <label>
                    {" "}
                    {item?.is_name || item.field_name || item.label}
                  </label>
                  <input
                    className="form-control"
                    defaultValue={values
                      ?.map(({ label, value }) => item[label] || row[value])
                      .join("|")}
                    readOnly
                  />
                </div>
              );
            })
          )}
          {isFields.map((item, _i) => {
            const label = item.label.split("-")[0];
            const {
              display,
              is_name,
              input_type,
              child_fields,
              child_api,
              child_params,
              value,
              Textarea,
              Required,
            } = item;
            if (child_fields && child_fields.length > 0) {
              ref.current = {
                url: child_api?.url,
                alias: value,
              };
              refParams.current = child_params;
              if (
                child_params.length > 0 &&
                child_params.find(({ value }) => value === "4SLCXTT")
              ) {
                refParam.current = dataChange?.[dataUpdate]?.["4SLCXTT"];
                // setParams(dataChange?.[dataUpdate]?.["4SLCXTT"]);
              }
            }
            return item.display ? (
              <>
                <div className="mb-3" key={_i}>
                  <label key={item.id} className="form-label">
                    {item?.is_name || label}
                    {Required && <span style={{ color: "red" }}> *</span>}
                  </label>
                  {Textarea ? (
                    <textarea
                      className="form-control"
                      onChange={(e) => {
                        const { value } = e.target;
                        handleInputChange(value, item.value, item.DATATYPE);
                      }}
                      rows={3}
                    >
                      {dataChange[dataUpdate]?.[item?.value]}
                    </textarea>
                  ) : child_fields && child_fields.length > 0 ? (
                    <>
                      <div className="d-flex align-items-center">
                        <Select
                          components={{
                            Option: CustomOption,
                          }}
                          options={isData}
                          onChange={(opt) => {
                            const mappedOpt = opt.map((item) => {
                              const { QC, SoLuong } = item;
                              const Tan = (SoLuong * QC) / 1000;
                              const SoLuongCanLay = Math.min(params, Tan);
                              const SoBao =
                                params - Tan > 0
                                  ? SoLuong
                                  : Math.ceil((params * 1000) / QC);

                              const SoLuongChuaXuat = SoLuong - SoBao;
                              const TanChuaXuat = (Tan - SoLuongCanLay).toFixed(
                                2
                              );

                              return {
                                ...item,
                                "SL Cần Xuất": `${SoBao} Bao\n${SoLuongCanLay} Tấn`,
                                "SL Đóng Bao Chưa Xuất": `${SoLuongChuaXuat} Bao\n${TanChuaXuat} Tấn`,
                              };
                            });

                            if (params) {
                              setDataSuggestion(mappedOpt);
                            }
                            setDataSuggestion([]);
                            setSelectedOption(opt);
                            handleInputChange(opt, item.value);
                            setCloneDataChange(mappedOpt);
                            // setTempData(opt, item, {}, undefined, isBulkUpdate);
                            // handleChangeData(
                            //   opt,
                            //   item,
                            //   {},
                            //   undefined,
                            //   isBulkUpdate
                            // );
                          }}
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          isSearchable={true}
                          value={
                            selectedOption ||
                            dataSuggestion ||
                            dataChange[dataUpdate]?.[item?.value]
                          }
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "300px",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          additional={{
                            page: 0,
                          }}
                          isMulti
                        />
                        <button
                          type="button"
                          className="btn btn-success mt-0 ml-4"
                          onClick={() => {
                            setCallDataSuggestion({
                              state: true,
                              alias: item.value,
                              item: item,
                              isBulkUpdate: isBulkUpdate,
                            });
                          }}
                        >
                          Gợi ý
                        </button>
                      </div>
                      <div style={{ overflow: "auto" }}>
                        <Table className="table table-custom mt-3">
                          <thead>
                            <tr>
                              {child_fields.map((field) => (
                                <td>
                                  {field.label ||
                                    field.trees.map(
                                      (tree) => tree.field_name || tree.label
                                    )}
                                </td>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {cloneDataChange &&
                              cloneDataChange.length > 0 &&
                              cloneDataChange.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    {child_fields.map((field, fieldIndex) => {
                                      return (
                                        <td
                                          style={{
                                            color: field.color,
                                            whiteSpace: "pre",
                                          }}
                                        >
                                          {item[field.label] ||
                                            field.trees.map((tree) =>
                                              item[tree.value] ? (
                                                <>
                                                  {item[tree.value]}
                                                  <br />
                                                </>
                                              ) : null
                                            )}
                                        </td>
                                      );
                                      // return (
                                      //   <td key={fieldIndex}>
                                      //     {item[field.value]}
                                      //   </td>
                                      // );
                                    })}
                                  </tr>
                                );
                              })}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    // <Item
                    //   DATATYPE={item.DATATYPE}
                    //   handleChange={(value) => {
                    //     handleChangeData(value, item, {}, dataUpdate, true);
                    //     // console.log("VALUE:",value)
                    //   }}
                    // />
                    <input
                      className="form-control"
                      type={item.DATATYPE === "TEXT" ? "text" : "number"}
                      min={0}
                      onChange={(e) => {
                        const { value } = e.target;
                        // const numericValue = parseFloat(value);
                        const numericValue = parseFloat(value).toFixed(3);

                        if (!isNaN(numericValue) && numericValue < 0) {
                          handleChangeData(0, item.value, item.DATATYPE);
                        } else {
                          handleInputChange(
                            Number(numericValue),
                            item.value,
                            item.DATATYPE
                          );
                          // handleChangeData(value, item, {}, dataUpdate, true);
                          if (
                            refParams.current &&
                            refParams.current.length > 0 &&
                            refParams.current.find(
                              ({ value }) => value === item.value
                            )
                          ) {
                            setCloneDataChange([]);
                            setDataSuggestion([]);
                            setParams(Number(numericValue));
                          }
                        }
                      }}
                      defaultValue={dataChange?.[dataUpdate]?.[item?.value]}
                    />
                  )}
                </div>
              </>
            ) : null;
          })}
        </form>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            onClick={() => {
              setRenderEdit(false);
              setTempData({});
            }}
          >
            {lang["btn.close"]}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            onClick={() => {
              if (
                tempHandleChange &&
                Object.values(tempHandleChange).length > 0
              ) {
                const { res, item, ex, isBulkUpdate } = tempHandleChange;
                handleChangeData(res, item, ex, dataUpdate, isBulkUpdate);
              }
              if (tempData && Object.values(tempData).length > 0) {
                setChangeData((prev) => {
                  const newPrev = [...prev];
                  if (newPrev[dataUpdate]) {
                    newPrev[dataUpdate] = {
                      ...newPrev[dataUpdate],
                      ...tempData,
                    };
                  }
                  return newPrev;
                });
                SETDATA((prev) => {
                  const newPrev = { ...prev };
                  if (newPrev[field.id][dataUpdate]) {
                    newPrev[field.id][dataUpdate] = {
                      ...newPrev[field.id][dataUpdate],
                      ...tempData,
                    };
                  }
                  // console.log("WJATIPSS", newPrev[field.id][dataUpdate]);
                  return newPrev;
                });
              }
              setRenderEdit(false);
            }}
          >
            {lang["btn.update"]}
          </button>
        </div>
      </>
    ) : (
      <>
        <form style={{ padding: "5px 5em" }}>
          {isFields.map((item) => {
            const label = item.label.split("-")[0];
            const {
              display,
              is_name,
              input_type,
              child_fields,
              child_api,
              child_params,
              value,
              Textarea,
              Required,
            } = item;
            if (!ref.current && child_fields && child_fields.length > 0) {
              ref.current = {
                url: child_api?.url,
                alias: value,
              };
              refParams.current = child_params;
            }
            return (
              display && (
                <div className="mb-3">
                  <label key={item.id} className="form-label">
                    {is_name || label}
                    {Required && <span style={{ color: "red" }}> *</span>}
                  </label>
                  {Textarea ? (
                    <textarea
                      className="form-control"
                      onChange={(e) => {
                        handleChangeData(
                          e.target.value,
                          item,
                          {},
                          undefined,
                          isBulkUpdate
                        );
                      }}
                      rows={3}
                    ></textarea>
                  ) : child_fields && child_fields.length > 0 ? (
                    <>
                      <div className="d-flex align-items-center">
                        <Select
                          components={{
                            Option: CustomOption,
                          }}
                          options={isData}
                          onChange={(opt) => {
                            const mappedOpt = opt.map((item) => {
                              const { QC, SoLuong } = item;
                              const Tan = (SoLuong * QC) / 1000;
                              const SoLuongCanLay = Math.min(params, Tan);
                              const SoBao =
                                params - Tan > 0
                                  ? SoLuong
                                  : Math.ceil((params * 1000) / QC);
                              const SoLuongChuaXuat = SoLuong - SoBao;
                              const TanChuaXuat = (Tan - SoLuongCanLay).toFixed(
                                2
                              );
                              return {
                                ...item,
                                "SL Cần Xuất": `${SoBao} Bao\n${SoLuongCanLay} Tấn`,
                                "SL Đóng Bao Chưa Xuất": `${SoLuongChuaXuat} Bao\n${TanChuaXuat} Tấn`,
                              };
                            });
                            if (params) {
                              setDataSuggestion(mappedOpt);
                            }
                            setSelectedOption(opt);
                            handleChangeData(
                              mappedOpt,
                              item,
                              {},
                              undefined,
                              isBulkUpdate
                            );
                          }}
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          isSearchable={true}
                          value={
                            selectedOption?.length
                              ? selectedOption
                              : dataSuggestion
                          }
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "300px",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          additional={{
                            page: 0,
                          }}
                          isMulti
                        />
                        <button
                          type="button"
                          className="btn btn-success mt-0 ml-4"
                          onClick={() => {
                            if (params) {
                              setCallDataSuggestion({
                                state: true,
                                alias: item.value,
                                item: item,
                                isBulkUpdate: isBulkUpdate,
                              });
                            }
                          }}
                        >
                          Gợi ý
                        </button>
                      </div>
                      <div style={{ overflow: "auto" }}>
                        <Table className="table table-custom mt-3">
                          <thead>
                            <tr>
                              {child_fields.map((field) => (
                                <td className="align-center">
                                  {field.label ||
                                    field.trees.map(
                                      (item) => item.field_name || item.value
                                    )}
                                </td>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {dataSuggestion &&
                              dataSuggestion.length > 0 &&
                              dataSuggestion.map((item, index) => (
                                <tr key={index}>
                                  {child_fields.map((field, fieldIndex) => {
                                    return (
                                      <td
                                        key={fieldIndex}
                                        style={{
                                          color: field?.color
                                            ? field?.color
                                            : "unset",
                                          textAlign: "left",
                                          whiteSpace: "pre",
                                        }}
                                      >
                                        {item[field.label] ||
                                          field.trees.map((tree) =>
                                            item[tree.value] ? (
                                              <>
                                                {item[tree.value]}
                                                <br />
                                              </>
                                            ) : null
                                          )}
                                        {/* {Array.isArray(item[field.value])
                                          ? item[field.value].map(
                                              (item) => item.text
                                            )
                                          : item[field.value]} */}
                                      </td>
                                    );
                                  })}
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    <input
                      className="form-control"
                      type={item.DATATYPE === "TEXT" ? "text" : "number"}
                      min={0}
                      onChange={(e) => {
                        const { value } = e.target;
                        // const numericValue = parseFloat(value);
                        const numericValue = parseFloat(value).toFixed(3);

                        if (!isNaN(numericValue) && numericValue < 0) {
                          handleChangeData(
                            0,
                            item,
                            {},
                            undefined,
                            isBulkUpdate
                          );
                        } else {
                          handleChangeData(
                            Number(numericValue),
                            item,
                            {},
                            undefined,
                            isBulkUpdate
                          );
                          if (
                            refParams.current &&
                            refParams.current.length > 0 &&
                            refParams.current.find(
                              ({ value }) => value === item.value
                            )
                          ) {
                            setDataSuggestion([]);
                            setSelectedOption([]);
                            setParams(Number(numericValue));
                          }
                        }
                      }}
                    />
                  )}
                </div>
              )
            );
          })}
        </form>
        {/* <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            // onClick={() => {
            //   setDataSearch([]);
            //   // setData([])
            //   // setRenderTable(false);
            // }}
          >
            {lang["btn.close"]}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            // data-dismiss="modal"
            onClick={() => {
              setCallDataSuggestion({
                state: true,
                data: selectedOption,
              });
              setRenderTable(true);
              // setRefreshForm((prev) => prev + 1);
            }}
          >
            {lang["btn.update"]}
          </button>
        </div> */}
      </>
    );
  }

  return isFields.length === 0 ? (
    <form style={{ padding: "5px 5em" }}>
      {showFields.map((item) => {
        const label = item.label.split("-")[0];
        return (
          item.display && (
            <div className="mb-3">
              <label key={item.id} className="form-label">
                {item?.is_name || label}
              </label>
              {item.input_type ? (
                <textarea
                  className="form-control"
                  onChange={(e) => {
                    handleChangeData(e.target.value, item);
                  }}
                  rows={6}
                >
                  {/* {dataChange[0]?.[item?.value]} */}
                </textarea>
              ) : item.DATATYPE === "INT UNSIGNED" ? (
                <Select />
              ) : (
                <input
                  className="form-control"
                  type={item.DATATYPE === "TEXT" ? "text" : "number"}
                  onChange={(e) => {
                    handleChangeData(e.target.value, item);
                  }}
                  min={0}
                  // defaultValue={dataChange[0]?.[item?.value]}
                />
              )}
            </div>
          )
        );
      })}
      {/* {(dataUpdate && dataUpdate.length > 0 ? dataUpdate : dataSearch)?.map(
        (row, index) => {
          return (
            <>
              {mappedData.map((item) => {
                  const values = item?.values;
                  return (
                    <div className="mb-3">
                      <label key={item.id} className="form-label">
                        {item.field_name}
                      </label>
                      {values.length > 1 ? (
                        <input
                          className="form-control"
                          disabled
                          readonly
                          value={values
                            .map(
                              ({ label, value }) =>
                                `${item[label] || row[value]}`
                            )
                            .join("_")}
                        />
                      ) : (
                        <input
                          className="form-control"
                          disabled
                          readonly
                          value={
                            item[values?.[0]?.label] ||
                            row[values?.[0]?.value]
                          }
                        />
                      )}
                    </div>
                  );
                })}
            </>
          );
        }
      )} */}
    </form>
  ) : null;
};

export default function TableInput(props) {
  const { lang, functions, proxy, database } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const [currentPage, setCurrentPage] = useState(1);
  const [refreshPage, setRefreshPage] = useState(0);
  const [mappedData, setMappedData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [renderEdit, setRenderEdit] = useState(false);
  const [renderEditInUpdate, setRenderEditInUpdate] = useState(false);
  const [dataUpdate, setDataUpdate] = useState(null);
  const [dataChangeInUpdate, setDataChangeUpdate] = useState([]);
  const [mergeData, setMergeData] = useState([]);
  const [isFields, setFields] = useState([]);
  const [getData, setGetData] = useState([]);
  const { normalizeStringAccent } = functions;
  const ID = useId();
  const {
    dataShowTable,
    dataSearch,
    dataForegin,
    showFields,
    allFields,
    setData,
    field,
    setDataSearch,
    showModal,
    dataChange,
    setChangeData,
    selectedValue,
    fieldChangeData,
    apiGet,
    apiDelete,
    param,
    PUBLIC_API,
    isBulkUpdate,
    setRenderTable,
    setRefreshForm,
    pk,
    loadOptions,
    handleChange,
    displayField,
    setDataDelete,
    setSelectedValue,
    isDataDelete,
    changeTrigger,
    stateCheck,
    refID,
  } = props;
  const dataChangeRef = useRef(dataChange);
  // console.log("dataChange", dataChange);
  const { component } = dataForegin;
  const buttons = component?.[0]?.props?.buttons;
  const rowsPerPage = 15;
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const [newState, setNewState] = useState(dataChange);
  useEffect(() => {
    if (dataChange && dataChange.length > 0) {
      dataChangeRef.current = dataChange;
    }
  }, [dataChange]);
  useEffect(() => {
    if (apiGet) {
      fetch(`${proxy()}${apiGet.api_detail.url}/${param}`, {
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, data, DisplayFields, FIELDS } = res;
          if (success) {
            const filteredData = data.filter((item) => {
              if (item.criteria && isDataDelete && isDataDelete.length > 0) {
                const criteriaValues = Object.values(item.criteria);
                const isDuplicate = isDataDelete.some((deleteItem) =>
                  criteriaValues.includes(deleteItem)
                );
                return !isDuplicate;
              }
              return true;
            });
            setGetData(filteredData);
          }
        });
    }
  }, [apiGet, param, isFields, isDataDelete]);

  useEffect(() => {
    const mappedFields = showFields.map((item) => {
      const label = item.label.split("-")[0];
      const findFields = allFields.find(
        ({ field_name }) => field_name === label
      );
      return {
        ...item,
        ...findFields,
      };
    });
    const mappedValues = [];
    dataShowTable.map((item) => {
      const values = item?.value;
      values.map(({ label, value }) => {
        let alias = label?.split("-$")?.at(-1)?.split(".")?.at(-1);
        const findValues = mappedFields.find(
          (f) => f?.field_alias === alias.split("-")[0]
        );
        if (findValues) {
          mappedValues.push({
            ...findValues,
            values,
          });
        }
      });
      if (mappedFields.find((f) => f?.label === item.label)) {
        mappedValues.push(item);
      }
    });
    const updatedShowFields = showFields.map((field, index) => {
      const lastIndex = dataSearch.length - 1;
      const lastItem = dataSearch[lastIndex];

      if (lastItem) {
        return {
          ...field,
          dataId: lastItem._id,
          parentIdx: isBulkUpdate ? undefined : lastIndex,
        };
      } else {
        return field;
      }
    });
    setFields(updatedShowFields);
    setMappedData(
      showFields
        .map((item) => {
          if (!item.display) {
            return {
              ...item,
              values: [{ label: item.label, value: item.value }],
            };
          }
        })
        .filter(Boolean)
    );
  }, [showFields, dataShowTable, allFields, dataSearch]);

  useEffect(() => {
    if (selectedValue && selectedValue.length === 0) {
      setChangeData([]);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (dataSearch.length > 0) {
      const checkData = Array.isArray(selectedValue)
        ? selectedValue
        : [selectedValue];

      const filterMergeData = dataSearch.filter((item1) =>
        checkData.some(
          (item2) =>
            JSON.stringify(item1?.value) === JSON.stringify(item2?.value)
        )
      );

      const mergeData = [
        ...getData,
        ...filterMergeData.map((item) => ({
          ...item,
          ...item.value,
        })),
      ];

      setChangeData((prev) => {
        const newPrev = [...prev];
        if (newPrev.length > 0) {
          mergeData.forEach((mergeItem) => {
            const exists = newPrev.some(
              (prevItem) => prevItem.label === mergeItem.label
            );
            if (!exists) {
              newPrev.push(mergeItem);
            }
          });
        } else {
          return mergeData;
        }
        return newPrev;
      });
      setMergeData(mergeData);
    } else {
      setMergeData([]);
    }
  }, [getData, dataSearch, selectedValue]);
  // const handleChangeData = (value, item, data, index, isUpdate) => {

  const handleChangeData = (value, alias, row, idx, isBulkUpdate) => {
    // if (isUpdate) {
    //   setMergeData((prev) => {
    //     const newPrev = prev.length > 0 ? [...prev] : [...getData];
    //     console.log("WHATSUP", newPrev)
    //     if (newPrev[index]) {
    //       if (newPrev[index][item.value]) {
    //         newPrev[index][item.value] = value;
    //       } else {
    //         newPrev[index] = {
    //           ...newPrev[index],
    //           [item.value]: value,
    //         };
    //       }
    //     } else {
    //       newPrev.push({
    //         ...data,
    //         [item.value]: value,
    //         id: data?._id || ID,
    //       });
    //     }
    //     changeTrigger(newPrev, field);
    //     return newPrev;
    //   });
    // }else{
    // }

    const lastIndex = mergeData.length - 1;
    const index =
      idx !== undefined ? idx : alias?.parentIdx ? alias?.parentIdx : lastIndex;

    if (isBulkUpdate) {
      setChangeData((prev) => {
        const newPrev = [...prev];
        if (newPrev[index]) {
          if (newPrev[index][alias.value]) {
            newPrev[index][alias.value] = value;
          } else {
            newPrev[index] = {
              ...newPrev[index],
              [alias.value]: value,
            };
          }
        } else {
          newPrev.push({
            ...row,
            [alias.value]: value,
            id: row?._id || ID,
          });
        }
        return newPrev;
      });

      // setChangeData((prev) => {
      //   const data =
      //     dataChange && dataChange.length > 0 ? dataChange : mergeData;
      //   const newPrev = [...data];
      //   // newPrev[index][alias.value] = value
      //   if (newPrev[index]) {
      //     if (newPrev[index][alias.value]) {
      //       newPrev[index][alias.value] = value;
      //     } else {
      //       newPrev[index] = {
      //         ...newPrev[index],
      //         [alias.value]: value,
      //       };
      //     }
      //   } else {
      //     newPrev.push({
      //       ...row,
      //       [alias.value]: value,
      //       id: newPrev[index]?._id || row?._id,
      //     });
      //   }
      //   console.log("HOLAAA", newPrev);
      //   return newPrev;
      // });
      // setData((prev) => {
      //   const newData = prev;
      //   const commonItems = dataSearch.filter((item) =>
      //     newData[field?.id]?.some((newItem) => newItem._id === item._id)
      //   );
      //   if (commonItems && commonItems.length > 0) {
      //     const updatedItem = [...commonItems];
      //     if (newData[field?.id]?.[index]) {
      //       newData[field?.id][index] = {
      //         ...newData[field?.id][index],
      //         [alias.value]: value,
      //       };
      //     } else {
      //       if (mergeData[index]) {
      //         mergeData[index] = {
      //           ...mergeData[index],
      //           [alias.value]: value,
      //         };
      //         newData[field?.id] = [...mergeData];
      //       }
      //     }
      //     console.log("CHECKHERE", newData);
      //     return newData;
      //   } else {
      //     PUBLIC_API.current[field?.id] = field;
      //     if (newData[field?.id]?.[idx]) {
      //       newData[field?.id][idx] = {
      //         ...newData[field?.id][idx],
      //         [alias.value]: value,
      //       };
      //     } else {
      //       const newMerge =
      //         dataChange && dataChange.length > 0 ? dataChange : mergeData;
      //       newData[field?.id] = [...newMerge];
      //     }
      //     console.log("CHECKHERE", newData);
      //     // fieldChangeData(newData[field?.id])
      //     return newData;
      //   }
      // });
    } else {
      // const { value } = e.target;
      const lastIndex = dataChange.length
        ? dataChange.length - 1
        : dataSearch.length - 1;

      const index =
        idx !== undefined ? idx : lastIndex ? lastIndex : alias?.parentIdx;

      if (dataSearch && dataSearch.length > 0) {
        setChangeData((prev) => {
          let newPrev = stateCheck ? prev : [...prev];

          if (newPrev[index]) {
            newPrev[index] = {
              ...newPrev[index],
              [alias.value]: value,
            };
          } else {
            const newDta = [...dataSearch];

            newDta[index] = {
              ...newDta[index],
              [alias.value]: value,
              id: dataSearch[index]?._id || row,
            };

            newPrev.push(newDta[index]);
            // newPrev.push({
            //   ...row,
            //   [alias.value]: value,
            //   id: dataSearch[index]?._id || row,
            // });
          }

          return newPrev;
        });
        setData((prev) => {
          const newData = prev;

          const commonItems = dataSearch.filter((item) =>
            newData[field?.id]?.some(
              (newItem) =>
                newItem._id === item._id &&
                newItem?.deliveryDetailId === item?.deliveryDetailId
            )
          );

          if (commonItems && commonItems.length > 0) {
            const updatedItem = [...commonItems];

            if (newData[field?.id]?.[index]) {
              newData[field?.id][index] = {
                ...newData[field?.id][index],
                [alias.value]: value,
              };
            } else {
              // updatedItem[index] = {
              //   ...updatedItem[index],
              //   [alias.value]: value,
              // };
              newData[field.id] = updatedItem;
            }
            // updatedItem[index] = {
            //   ...updatedItem[index],
            //   [alias.value]: value,
            // };
            // newData[field.id] = updatedItem;

            return newData;
          } else if (PUBLIC_API) {
            PUBLIC_API.current[field?.id] = field;

            if (newData[field?.id]?.[idx]) {
              newData[field?.id][idx] = {
                ...newData[field?.id][idx],
                [alias.value]: value,
              };
            } else {
              newData[field?.id] = [
                ...(newData[field?.id] || []),
                {
                  ...getData[idx],
                  [alias.value]: value,
                },
              ];
            }
            // GET_DATA.current = getData[idx].criteria;
            return newData;
          }
        });
      }
    }
  };

  if (showModal) {
    return (
      <RenderModal
        dataChange={dataChange}
        handleChangeData={handleChangeData}
        setChangeData={setChangeData}
        dataChangeRef={dataChangeRef}
        _token={_token}
        dataSearch={dataSearch}
        dataUpdate={dataUpdate}
        isBulkUpdate={isBulkUpdate}
        isFields={isFields}
        mappedData={mappedData}
        proxy={proxy}
        renderEdit={renderEdit}
        showFields={showFields}
      />
    );
  }

  // useEffect(() => {
  //     console.log("?")
  // }, [mergeData]);
  return (
    <div className="mt-3">
      <div
        className="table-responsive table-custom design-table"
        style={{ height: "auto", display: showTable ? "none" : "block" }}
        key={refreshPage}
      >
        <table>
          <thead>
            <tr>
              <td className="index" style={{ zIndex: "9" }}>
                #
              </td>
              {/* {mappedData.map((item) => {
                return <td key={item.id}>{item.field_name}</td>;
              })} */}
              {isFields.map((item) => {
                const label = item.label.split("-")[0];
                return <td key={item.id}>{item.is_name || label}</td>;
              })}
              {/* {isBulkUpdate ? null : ( */}
              <td
                class="align-center position-sticky"
                style={{
                  right: "0px",
                }}
              >
                {lang["Actions"]}
              </td>
              {/* )} */}
            </tr>
          </thead>
          <tbody>
            {mergeData && mergeData.length > 0
              ? mergeData.map((row, index) => {
                  return (
                    <tr key={index}>
                      <td
                        class="align-center"
                        scope="row"
                        style={{ minWidth: "50px" }}
                        className="index"
                      >
                        {indexOfFirst + index + 1}
                      </td>
                      {mappedData.map((item, idx) => {
                        const values = item?.values || item.value;
                        return (
                          <td key={idx} className="cell">
                            {values?.map(({ label, value }) => {
                              return (
                                <p
                                  style={{ color: "unset", whiteSpace: "pre" }}
                                >
                                  {item[label] || row[value] || row[values]}
                                </p>
                              );
                            })}
                          </td>
                        );
                      })}
                      {showFields.map((item, indx) => {
                        const { DATATYPE = "" } = item;
                        return (
                          item.display && (
                            <td className="cell" key={indx}>
                              <input
                                className="form-control"
                                step="any"
                                type={
                                  DATATYPE === "TEXT" ||
                                  DATATYPE === "INT UNSIGNED"
                                    ? "text"
                                    : "number"
                                }
                                onBlur={(e) => {
                                  const { value } = e.target;
                                  const numericValue =
                                    parseFloat(value).toFixed(3);

                                  if (numericValue) {
                                    setChangeData((prev) => {
                                      const newPrev = [...prev];
                                      newPrev[index] = {
                                        ...newPrev[index],
                                        [item.alias]: Number(numericValue),
                                      };
                                      return newPrev;
                                    });
                                    handleChangeData(
                                      Number(numericValue),
                                      item,
                                      row,
                                      index,
                                      isBulkUpdate
                                    );
                                  }
                                }}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  const numericValue = parseFloat(value);
                                  if (
                                    !isNaN(numericValue) &&
                                    numericValue < 0
                                  ) {
                                    handleChangeData(
                                      0,
                                      item,
                                      row,
                                      index,
                                      isBulkUpdate
                                    );
                                  } else {
                                    handleChangeData(
                                      value,
                                      item,
                                      row,
                                      index,
                                      isBulkUpdate
                                    );
                                  }
                                }}
                                readOnly={item.child_api ? true : false}
                                onKeyDown={(e) => {
                                  if (e.keyCode === 8) {
                                    const { value } = e.target;
                                    handleChangeData(
                                      value,
                                      item,
                                      row,
                                      index,
                                      isBulkUpdate
                                    );
                                  }
                                }}
                                value={
                                  Array.isArray(dataChange[index]?.[item.value])
                                    ? dataChange[index][item.value].map(
                                        (ldb) => ldb[item.value]
                                      )
                                    : dataChange[index]?.[item.value] !==
                                        undefined &&
                                      dataChange[index]?.[item.value] !== null
                                    ? dataChange[index][item.value]
                                    : ""
                                  // row?.[item?.value]
                                  // dataSearch?.[index]?.[item?.value]
                                }
                              />
                            </td>
                          )
                        );
                      })}
                      <td
                        className="align-center actions"
                        style={{
                          right: "0px",
                          background: "rgb(255, 255, 255)",
                        }}
                      >
                        <div className="icon-table">
                          {Object.keys(buttons || {}).map((button, value) => {
                            switch (button) {
                              case "delete":
                                return (
                                  <div
                                    class="icon-table-line text-center"
                                    key={button}
                                    onClick={() => {
                                      Swal.fire({
                                        title: lang["confirm"],
                                        text: lang["confirm.content"],
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonText: lang["btn.delete"],
                                        cancelButtonText: lang["btn.cancel"],
                                        confirmButtonColor: "rgb(209, 72, 81)",
                                      }).then((result) => {
                                        // if(result.isConfirmed){
                                        //   setChangeData((prev)=>prev.filter(({_id})=> _id !== row._id))
                                        //   setMergeData((prev)=>prev.filter(({_id})=> _id !== row._id))
                                        //   setDataSearch((prev)=>prev.filter(({_id})=> _id !== row._id))

                                        //   console.log("WTHHHDE", mergeData, row._id);

                                        // }
                                        if (result.isConfirmed) {
                                          refID.current = row._id;
                                          if (row.criteria) {
                                            setDataDelete((prev) => {
                                              const newPrev = [
                                                ...prev,
                                                Object.values(row.criteria),
                                              ].flat();
                                              return newPrev;
                                            });
                                          }
                                          setSelectedValue((prev) =>
                                            prev.filter(
                                              (select) =>
                                                select.label !== row.label
                                            )
                                          );
                                          setChangeData((prev) =>
                                            prev.filter(
                                              (select) => select._id !== row._id
                                            )
                                          );

                                          // setData((prev) => {
                                          //   const newPrev = { ...prev };
                                          //   if (newPrev[field.id]) {
                                          //     newPrev[field.id] = newPrev[
                                          //       field.id
                                          //     ].filter(
                                          //       ({ _id }) => _id !== row._id
                                          //     );
                                          //     console.log("newPrevnewPrev", newPrev[field.id])

                                          //     changeTrigger(
                                          //       newPrev[field.id],
                                          //       field
                                          //     );
                                          //   }

                                          //   return newPrev;
                                          // });

                                          setMergeData((prev) => {
                                            let newPrev = [...prev];
                                            newPrev = newPrev.filter(
                                              (item) => item._id !== row._id
                                            );
                                            // console.log("WHATzHREEE", newPrev);
                                            // setSelectedValue(newPrev);
                                            // changeTrigger(newPrev);
                                            return newPrev;
                                          });

                                          return;
                                          if (row.criteria) {
                                            setDataDelete((prev) => {
                                              const newPrev = [
                                                ...prev,
                                                Object.values(row.criteria),
                                              ].flat();
                                              return newPrev;
                                            });
                                          }

                                          setDataSearch((prev) =>
                                            prev.filter(
                                              ({ _id }) => _id !== row._id
                                            )
                                          );
                                          setGetData((prev) =>
                                            prev.filter(
                                              ({ _id }) => _id !== row._id
                                            )
                                          );
                                          const filterMergeData =
                                            mergeData.filter(
                                              ({ _id }) => _id !== row._id
                                            );
                                          const newSelectedValue =
                                            selectedValue.filter((item1) =>
                                              filterMergeData.some(
                                                (item2) =>
                                                  JSON.stringify(
                                                    item1?.value
                                                  ) ===
                                                  JSON.stringify(item2?.value)
                                              )
                                            );
                                          setSelectedValue(newSelectedValue);
                                          handleChange(newSelectedValue);

                                          // setSelectedValue((prev)=>{
                                          //   const newPre
                                          // })
                                          // setMergeData((prev) =>
                                          //   prev.filter(
                                          //     (_, idx) => idx !== index
                                          //   )
                                          // );
                                          // setSelectedValue([]);
                                          // setData((prev) => {
                                          //   const newPrev = { ...prev };
                                          //   if (newPrev[field.id]) {
                                          //     newPrev[field.id] = newPrev[
                                          //       field.id
                                          //     ].filter(
                                          //       ({ _id }) => _id !== row._id
                                          //     );
                                          //     changeTrigger(
                                          //       newPrev[field.id],
                                          //       field
                                          //     );
                                          //   }
                                          //   console.log("WHATSROW", newPrev);

                                          //   return newPrev;
                                          // });

                                          setChangeData((prev) =>
                                            prev.filter(
                                              ({ _id }) => _id !== row._id
                                            )
                                          );
                                        }
                                      });
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      className="size-20 pointer icon-delete"
                                      title={lang["delete"]}
                                    />
                                  </div>
                                );
                              case "update":
                                return (
                                  <div
                                    key={button}
                                    className="icon-table-line text-center"
                                    data-toggle="modal"
                                    data-target="#renderEdit"
                                    data-backdrop="static"
                                    onClick={() => {
                                      let merged = {
                                        ...dataChange[index],
                                        ...row,
                                      };
                                      setRenderEdit(true);
                                      // setRenderEditInUpdate(true);
                                      setDataUpdate(index);
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faEdit}
                                      className="fa fa-edit size-20 pointer icon-edit"
                                      title={lang["delete"]}
                                    />
                                  </div>
                                );
                            }
                          })}
                        </div>
                      </td>
                    </tr>
                  );
                })
              : getData &&
                getData.length > 0 &&
                getData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        class="align-center"
                        scope="row"
                        style={{ minWidth: "50px" }}
                        className="index"
                      >
                        {indexOfFirst + index + 1}
                      </td>
                      {isFields.map((field, idx) => {
                        return field.display ? (
                          <td className="cell" key={idx}>
                            <input
                              className="form-control"
                              type={field.DATATYPE.toLowerCase()}
                              onChange={(e) => {
                                handleChangeData(
                                  e.target.value,
                                  field,
                                  field.id,
                                  index,
                                  isBulkUpdate
                                );
                              }}
                              min={0}
                              value={
                                dataChange?.[index]?.[field?.value] ||
                                dataSearch?.[index]?.[field?.value] ||
                                item[field?.value]
                              }
                            />
                          </td>
                        ) : (
                          <td>{item[field?.value]}</td>
                        );
                      })}
                      <td
                        className="align-center actions"
                        style={{
                          right: "0px",
                          background: "rgb(255, 255, 255)",
                        }}
                      >
                        <div className="icon-table">
                          <div
                            className="icon-table-line text-center"
                            data-toggle="modal"
                            data-target="#renderEditInUpdate"
                            data-backdrop="static"
                            onClick={() => {
                              setRenderEditInUpdate(true);
                              setDataChangeUpdate({ index, ...item });
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faEdit}
                              className="fa fa-edit size-20 pointer icon-edit"
                              title={lang["update"]}
                            />
                          </div>
                          <div
                            class="icon-table-line text-center"
                            onClick={() => {
                              Swal.fire({
                                title: lang["confirm"],
                                text: lang["confirm.content"],
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonText: lang["btn.delete"],
                                cancelButtonText: lang["btn.cancel"],
                                confirmButtonColor: "rgb(209, 72, 81)",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  setGetData((prev) =>
                                    prev.filter(({ _id }) => _id !== item._id)
                                  );
                                  if (item.criteria) {
                                    setDataDelete((prev) => {
                                      const newPrev = [
                                        ...prev,
                                        Object.values(item.criteria),
                                      ].flat();
                                      return newPrev;
                                    });
                                  }

                                  setData((prev) => {
                                    const newPrev = { ...prev };
                                    if (newPrev[field.id]) {
                                      newPrev[field.id] = newPrev[
                                        field.id
                                      ].filter((_, idx) => idx !== index);
                                    }
                                    return newPrev;
                                  });
                                  setChangeData((prev) =>
                                    prev.filter((_, idx) => idx !== index)
                                  );
                                }
                              });
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              className="size-20 pointer icon-delete"
                              title={lang["delete"]}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
      {renderEdit ? (
        <div
          class="modal fade"
          id="renderEdit"
          tabindex="-1"
          aria-labelledby="renderEdit"
          aria-hidden="true"
          data-backdrop="static"
        >
          <div className="modal-dialog">
            <div className="modal-content custome">
              <div className="modal-header justify-content-start">
                <span style={{ fontSize: "18px" }}>{lang["edit"]}</span>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  onClick={() => setRenderEdit(false)}
                >
                  &times;
                </button>
              </div>
              <div
                className="modal-body"
                style={{
                  height: "70vh",
                  overflowY: "auto",
                  overflowX: "unset",
                }}
              >
                <RenderModal
                  dataChange={dataChange}
                  handleChangeData={handleChangeData}
                  setChangeData={setChangeData}
                  dataChangeRef={dataChangeRef}
                  _token={_token}
                  dataSearch={dataSearch}
                  dataUpdate={dataUpdate}
                  isBulkUpdate={isBulkUpdate}
                  isFields={isFields}
                  mappedData={mappedData}
                  proxy={proxy}
                  renderEdit={renderEdit}
                  showFields={showFields}
                  setRenderEdit={setRenderEdit}
                  lang={lang}
                  SETDATA={setData}
                  field={field}
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {renderEditInUpdate ? (
        <ModalEditInUpdate
          handleChange={handleChange}
          loadOptions={loadOptions}
          pk={pk}
          data={dataChangeInUpdate}
          fields={showFields}
          handleChangeData={handleChangeData}
          setRenderEditInUpdate={setRenderEditInUpdate}
          setRefreshPage={setRefreshPage}
          displayField={displayField}
          dataShowTable={dataShowTable}
          setDataDelete={setDataDelete}
        />
      ) : null}
    </div>
  );
}
